import { Routes } from '@angular/router';
import { AppRoutes, blockWebVersionGuard, HostedGamesRoutes } from '@core';
import {
  CreateGameComponent,
  HostedGameDetailsComponent,
  InvitePlayersComponent,
  ReassignGameComponent
} from './components';
import { createGameGuard } from './application/guards';
import { reassignGameResolver } from './application/resolvers';
import { isAuthedGuard } from '@auth';

export const HostedGamesRouting: Routes = [
  {
    path: HostedGamesRoutes.ROOT,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: HostedGamesRoutes.FUTURE,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: HostedGamesRoutes.PAST,
    redirectTo: `/${AppRoutes.MY_GAMES}`,
    pathMatch: 'full'
  },
  {
    path: `${HostedGamesRoutes.FUTURE}/:id`,
    component: HostedGameDetailsComponent,
    canActivate: [isAuthedGuard, blockWebVersionGuard]
  },
  {
    path: `${HostedGamesRoutes.FUTURE}/:id/${HostedGamesRoutes.INVITE}`,
    component: InvitePlayersComponent,
    canActivate: [isAuthedGuard, blockWebVersionGuard]
  },
  {
    path: HostedGamesRoutes.CREATE_GAME,
    component: CreateGameComponent,
    canActivate: [createGameGuard, isAuthedGuard, blockWebVersionGuard]
  },
  { path: `${HostedGamesRoutes.REASSIGN}/:gameId`, component: ReassignGameComponent, resolve: { reassignGameResolver } }
];
